import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

interface Props {
  style?: React.CSSProperties
  imgStyle?: React.CSSProperties
  objectFit?: 'contain' | 'cover'
  objectPosition?: string
  className?: string
}

export default function JustinMegaphone({ style, imgStyle, className, objectFit = 'cover', objectPosition = '50% 50%' }: Props) {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "images/justin-megaphone-large.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.desktop.childImageSharp.fluid}
      style={{ ...style }}
      imgStyle={{ objectFit, objectPosition, ...imgStyle }}
      alt="Justin Jones speaking."
      className={className}
    />
  )
}
